import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { JwtHelperService } from "@auth0/angular-jwt";
import { 
  IAppSession, 
  IAppUser
} from './../app.store.interface';
import { IUser } from 'src/app/shared/src/lib/interfaces/user.interface';

const jwtHelper = new JwtHelperService();

const DEFAULT_MSG_PERIMSSION =
  'No tiene permisos para realizar acciones en esta opción';

const SNE_SESSION_KEY = 'SSO_SESION_ACTUAL';

export class AppSessionAction {
  constructor(
    private getState: () => IAppSession,
    private setState: (newState: IAppSession) => void
  ) {}

  //=======================================================
  // ACCIONES QUE MODIFICAN EL ESTADO
  //=======================================================
  restablecerSesionDeLocalStorage = () => {
    const token = localStorage.getItem(SNE_SESSION_KEY);
    this.setSesion(token);
  }

  isToken = () =>{
    const token = localStorage.getItem(SNE_SESSION_KEY);
    return token;
  }

  login = (token: string) => {
    this.setSesion(token);
    //console.log('tokenValue', jwtHelper.decodeToken(token));

    localStorage.setItem(SNE_SESSION_KEY, token);
  }

  private setSesion = (token: string) => {
    const userSesion: IAppUser =  jwtHelper.decodeToken(token);
    //console.log('userSesion', userSesion);
    
    let displayUser: IUser = {
      fullName: userSesion.Name,
      email: userSesion.email,
      lastSession: null,
      avatarText: userSesion.Name.substr(0, 1),
      rolName: null,
      defaultRol: {
        NOMBRE_ROL: ''
      },
      roles: null
    }    

    this.setState({ 
      ...this.getState(), 
      token: token,
      user: userSesion,
      isLoading: true,
      displayUser: displayUser
    });
  }

  logout = () => {
    this.setState({
      ...this.getState(),
      isLoggedIn: false,
      user: null,
      token: null
    });
    
    localStorage.removeItem(SNE_SESSION_KEY);
  };

  getUserSesion = () : IAppUser => {
    return this.getState().user;
  }

  esSesionValida = () => {
    const token = localStorage.getItem(SNE_SESSION_KEY);

    return !jwtHelper.isTokenExpired(token);
  }

  //-----------------------------------------

  setSessionFromStorage = (session: IAppSession) => {
    this.setState({ ...session, fromStorage: true });
  };

  setNewToken = (token: string) => {
    this.setState({ ...this.getState(), token });
    //this.localStorage.set(SIU_SESSION_KEY, this.getState());
  };

  setAuthToken = (token: string, returnUrl: string) => {
    this.setState({ ...this.getState(), token: token, returnUrl: returnUrl });
  };

  loginBegin = () => {
    this.setState({ ...this.getState(), isLoading: true, loginError: false });
  };

  loginCompletar = () => {
    let state = this.getState();

    this.setState({
      ...state,
      isLoading: false,
      isLoggedIn: true
    });

    //console.log(this.getState());
  }

  loginSuccess = () => {
    // const user = this.buildUser(punkuClaims, siuClaims);

    this.setState({
      ...this.getState(),
      isLoading: false,
      isLoggedIn: true,
      //user
    });

    // this.localStorage.set(SIU_SESSION_KEY, this.getState());
  };

  loginError = () => {
    this.setState({ ...this.getState(), isLoading: false, loginError: true });
  };

  // setCurrentMenu = (url: string) => {
  //   const state = this.getState();
  //   const { MENU, ACCION } = state.claims;

  //   let item = MENU.find(x => x.RUTA_RELATIVA == url);

  //   if (!item) {
  //     const urlSplit = url.split('?');
  //     url = urlSplit[0];
  //     item = MENU.find(x => x.RUTA_RELATIVA == url);
  //   }

  //   let permissions = {};
  //   let rolPermissions = {};

  //   Object.keys(PUNKU_ACTIONS).forEach(key => {
  //     permissions[key] = false;
  //   });

  //   if (item) {
  //     ACCION.filter(x => x.GUID_MENU == item.GUID).forEach(x => {
  //       rolPermissions[x.NOMBRE] = true;
  //     });
  //   }

  //   const currentMenu: ICurrentMenu = {
  //     item: item ? item : null,
  //     permissions: { ...permissions, ...rolPermissions }
  //   };

  //   this.setState({ ...this.getState(), currentMenu });
  // };

  /**
   * Cierra la sesión y elimina el usuario
   * del storage
   */
  // logout = () => {
  //   this.setState({
  //     ...this.getState(),
  //     isLoggedIn: false,
  //     user: null
  //   });
  //   this.localStorage.remove(SIU_SESSION_KEY);
  // };

  setSessionExpired = () => {
    this.setState({ ...this.getState(), sessionExpired: true });
  };

  //=======================================================
  //actions que obtienen data del estado
  //=======================================================

  // checkHasClaim = (claim: IGuardClaim): boolean => {
  //   switch (claim.type) {
  //     case ClaimTypeEnum.URL: {
  //       const state = this.getState();

  //       const { MENU } = state.claims;
  //       const { ACCION } = state.claims;

  //       if (!MENU) return false;

  //       const menuFound = MENU.find(
  //         x => x.RUTA_RELATIVA.split('?')[0] == claim.path
  //       );

  //       if (!menuFound) return false;

  //       return (
  //         ACCION.find(
  //           x => x.GUID_MENU == menuFound.GUID && x.CODIGO == claim.action
  //         ) != undefined
  //       );
  //     }
  //     case ClaimTypeEnum.GUID:
  //       const state = this.getState();

  //       const { MENU } = state.claims;
  //       const { ACCION } = state.claims;

  //       if (!MENU) return false;

  //       let menuFound = state.claims.MENU.find(c => c.GUID == claim.value);

  //       if (!menuFound) return false;

  //       return (
  //         ACCION.find(
  //           c => c.GUID_MENU == menuFound.GUID && c.CODIGO == claim.action
  //         ) != undefined
  //       );
  //   }

  //   return true;
  // };

  /**
   * DEPRECATED
   */
  getUser = (): IAppUser => {
    const state = this.getState();

    return state.user;
  };

  //=======================================================
  //async actions
  //=======================================================

  // asyncLogin = () => {
  //   this.loginBegin();
  //   this.punkuService.login().subscribe(
  //     response => {
  //       if (response.punkuClaims.HasErrors) {
  //         this.loginError();
  //       } else {
  //         this.loginSuccess(response.punkuClaims, response.siuClaims);
  //       }
  //     },
  //     error => {
  //       this.loginError();
  //     }
  //   );
  // };

  // asyncCheckSession = () => {
  //   return this.punkuService
  //     .checkSession()
  //     .pipe(
  //       map(response => {
  //         if (!response.authorized) {
  //           return false;
  //         }
  //         return true;
  //       }),
  //       catchError(err => {
  //         console.error(err);
  //         return throwError(false);
  //       })
  //     )
  //     .toPromise();
  // };

  //=======================================================
  // HELPERS
  //=======================================================

  // private buildUser = (
  //   claims: IPunkuClaims,
  //   siuClaims: ISiuClaims
  // ): IAppUser => {
  //   if (!claims) return null;

  //   const { USUARIO, SESION, ROL_USUARIO } = claims;

  //   if (!USUARIO) return null;

  //   const ROLES: IAppUserRol[] = ROL_USUARIO.map(x => ({
  //     ...x,
  //     TIPO_ROL_SIU:
  //       x.DESCRIPCION_TIPO_SEDE == 'Oficina'
  //         ? TipoRolSiuEnum.INTERNO
  //         : TipoRolSiuEnum.EXTERNO
  //   }));

  //   const esEntidad = siuClaims && siuClaims.idEntidad;

  //   const DEFAULT_ROL: IAppUserRol = ROLES.filter(x => x.POR_DEFECTO).map(
  //     (x): IAppUserRol => ({
  //       ...x,
  //       ID_ENTIDAD: esEntidad ? siuClaims.idEntidad : null,
  //       PERMISSIONS: esEntidad ? this.buildAppPermissions(siuClaims) : null,
  //       NOMBRE_ENTIDAD: esEntidad ? siuClaims.nombreEntidad : null,
  //       TEXTO_AUTORIZACION: esEntidad ? siuClaims.textoAutorizacion : null,
  //       NOMBRE_SEDE: x.DESCRIPCION_SEDE,
  //       ID_TBL_TIPO_GESTION: esEntidad ? siuClaims.idTblTipoGestion : null,
  //       OFICINA:
  //         siuClaims && siuClaims.abreviaturaSede
  //           ? siuClaims.abreviaturaSede
  //           : null
  //     })
  //   )[0];

  //   const avatarText = `${USUARIO.NOMBRES.substring(
  //     0,
  //     1
  //   ).toUpperCase()}${USUARIO.APELLIDO_PATERNO.substring(0, 1).toUpperCase()}`;

  //   return {
  //     fullName: `${USUARIO.NOMBRES}, ${USUARIO.APELLIDO_PATERNO} ${USUARIO.APELLIDO_MATERNO}`,
  //     email: USUARIO.CORREO_ELECTRONICO,
  //     lastSession: SESION.FECHA_ULTIMA_SESION,
  //     avatarText,
  //     defaultRol: DEFAULT_ROL,
  //     roles: [...ROLES]
  //   };
  // };

  // private buildAppPermissions = (siuClaims: ISiuClaims): IAppPermissions => {
  //   let siuPermissions: IAppPermissions = { ...DEFAULT_PERMISSIONS };

  //   if (!siuClaims) {
  //     console.error('Error en el servicio de matríz de permisos.');
  //     return siuPermissions;
  //   }

  //   siuClaims.rules.forEach(rule => {
  //     const permission: IAppPermission = {
  //       msg: rule.desEstado,
  //       value: rule.estado
  //     };

  //     siuPermissions[rule.desTblAccionMatriz] = permission;
  //   });

  //   return siuPermissions;
  // };
}
